import { isQcColor } from '@ps/bridge/qc/base'
import gameIframe from '@ps/bridge/iframe/iframe'
import qc from 'qc'
import _ from 'lodash'

/**
 * 转换 qc color，如果是string，调用 qc.Color 转换，如果是 qc.Color 直接返回，其他返回 undefined
 * @param value
 */
export const toQcColor = (value: qc.Color | string) => {
  if (_.isString(value)) {
    const Color = gameIframe.qc.Color
    return new Color(value)
  } else if (isQcColor(value)) {
    return value
  }
}
